import { LOANS } from 'loans.module/common/domain/constants.loans';

class ModalDetailLoanController {

  constructor($window,myLoansService, LoansUserDataService) {
    'ngInject';
    this.isMobileApp = $window.innerWidth < 1024;
    this.myLoansService = myLoansService;
    this.loansUserDataService = LoansUserDataService;
    this.userId = this.loansUserDataService._employee.userId;
  }

  $onInit() {
    if(this.isMobileApp)
      this.floatingActionButtons = this.getFloatingActionButtons();
  }

  dismiss() {
    angular.element('.modal').modal('hide');
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.CLOSE'
      }
    ];
  }
  
  showGrantDatePurposeGranted() {
    return this.loan.statusCode === LOANS.STATES.ID.IN_FORCE ||
      this.loan.statusCode === LOANS.STATES.ID.AUTHORIZED ||
      this.loan.statusCode === LOANS.STATES.ID.SUBSCRIBER ||
      this.loan.statusCode === LOANS.STATES.ID.NOT_IN_FORCE ||
      this.loan.statusCode === LOANS.STATES.ID.PENDING ||
      this.loan.statusCode === LOANS.STATES.ID.PENDING_SIGNATURE ||
      this.loan.statusCode === LOANS.STATES.ID.DENIED ||
      this.loan.statusCode === LOANS.STATES.ID.ANNULATED ||
      this.loan.statusCode === LOANS.STATES.ID.REGRESSED ||
      this.loan.statusCode === LOANS.STATES.ID.DISCLAIMER;
  }

  showRestOfData() {
    return this.loan.statusCode === LOANS.STATES.ID.IN_FORCE ||
      this.loan.statusCode === LOANS.STATES.ID.AUTHORIZED ||
      this.loan.statusCode === LOANS.STATES.ID.SUBSCRIBER ||
      this.loan.statusCode === LOANS.STATES.ID.PENDING ||
      this.loan.statusCode === LOANS.STATES.ID.PENDING_SIGNATURE;
  }

  showOnlyInForce() {
    return this.loan.statusCode === LOANS.STATES.ID.IN_FORCE;
  }

  showTextInPending() {
    return this.loan.statusCode === LOANS.STATES.ID.PENDING ||
      this.loan.statusCode === LOANS.STATES.ID.PENDING_SIGNATURE ||
      this.loan.statusCode === LOANS.STATES.ID.DENIED ||
      this.loan.statusCode === LOANS.STATES.ID.ANNULATED ||
      this.loan.statusCode === LOANS.STATES.ID.REGRESSED ||
      this.loan.statusCode === LOANS.STATES.ID.DISCLAIMER;
  }

  showCancellationDate() {
    return this.loan.statusCode === LOANS.STATES.ID.NOT_IN_FORCE;
  }
}

export default ModalDetailLoanController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/modals/modalDetailLoan/modalDetailLoan.controller.js